export default Object.freeze({
    Yes: 1,
    No: 2,
  });
  